const asyncDelay = (ms) => new Promise((r) => setTimeout(r, ms));

export default asyncDelay;
